import React from 'react';
import { Link } from 'react-router-dom';

const BlogPreview = () => {
  const posts = [
    { id: 1, title: "Shaping Tomorrow's Health", excerpt: "The impact of childhood habits on adult health...", date: "April 15, 2024", icon: "🍎", bgColor: "bg-red-100" },
    { id: 2, title: "Nutrition Myths Debunked", excerpt: "Common misconceptions about diet and health...", date: "April 10, 2024", icon: "🥑", bgColor: "bg-green-100" },
    { id: 3, title: "The Power of Mindful Eating", excerpt: "How being present during meals can transform your relationship with food...", date: "April 5, 2024", icon: "🫐", bgColor: "bg-blue-100" },
  ];

  return (
      <div className="space-y-6">
        {posts.map((post) => (
            <div key={post.id} className="bg-white p-6 rounded-3xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-50">
              <div className="flex items-start gap-4">
                <div className={`${post.bgColor} w-14 h-14 rounded-full flex items-center justify-center text-2xl flex-shrink-0 shadow-inner`}>
                  {post.icon}
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    <Link to={`/blog/${post.id}`} className="hover:text-primary transition-colors">
                      {post.title}
                    </Link>
                  </h3>
                  <p className="text-gray-500 text-sm mb-3 font-medium">{post.excerpt}</p>
                  <time className="text-primary text-xs font-bold uppercase tracking-wider">{post.date}</time>
                </div>
              </div>
            </div>
        ))}
      </div>
  );
};

export default BlogPreview;